<template>
    <div class="coming">
      <i class="iconfont iconfanhui back" @click.stop="$router.back()">返回</i>
      <div>
       <img src="../../assets/images/genetic/coming.png" alt="敬请期待">
       <p>基于您的全基因及外显子数据，筛选部分未报道的位点，挖掘更多更准确的遗传疾病信息。涉及的遗传携带影响健康状态而非生育，是可控可干预的且干预后收益显著的。需要更全面的了解相关检测信息，检测后，阳性携带者建议接受临床及遗传咨询。</p>
      </div>
    </div>
</template>

<script>
export default {
  name: 'coming'
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";
  .coming {
    width: 100%;
    height: 100%;
    background: #fff;
    overflow: auto;

    .back {
      position: absolute;
      top: pxToRem(20px);
      left: pxToRem(20px);
      font-size: pxToRem(25px);
      color: #000;
    }

    > div {
      padding: 0 pxToRem(46px);
    }

    img {
      width: 100%;
      height: pxToRem(391px);
      margin-top: pxToRem(115px);
    }

    p {
      font-size: pxToRem(25px);
      font-weight: 300;
      color: #1A4D94;
      padding: pxToRem(60px) pxToRem(90px);
      letter-spacing: 1px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/genetic/coming.vue